import { Action } from '@ngrx/store';

import { BlindsChangedEvent } from '../../../../shared/events/blinds-changed.event';

export enum BlindActionTypes {
  SELECT_BLIND = '[Blind] Select Blind',
  NO_BLIND = '[Blind] No Blind',
  UPDATE_BLIND = '[Blind] Update Blind',
}

export class SelectBlind implements Action {
  readonly type = BlindActionTypes.SELECT_BLIND;

  constructor(public payload: BlindsChangedEvent) {}
}

export class NoBlind implements Action {
  readonly type = BlindActionTypes.NO_BLIND;
}

export class UpsertBlind implements Action {
  readonly type = BlindActionTypes.UPDATE_BLIND;

  constructor(public payload: BlindsChangedEvent) {}
}

export type BlindActionsUnion = SelectBlind | NoBlind | UpsertBlind;
